// Englische Fassung von ../de/documents.ts.
import type { DocumentsKatalog } from "../de/documents";

export const documents: DocumentsKatalog = {
  // ---- List (Documents.tsx) ----
  seitenTitel: "Documents",
  untertitel: "Upload a PDF or Markdown file",
  dateiZiehen: "Drop a file here or click",
  dateiTypen: ".pdf or .md",
  uploadAria: "Upload document (PDF/Markdown)",
  wirdHochgeladen: "uploading …",
  keineDokumente: "No documents yet",
  keineDokumenteHinweis: "Drag a PDF or Markdown file into the area above.",
  dateiAuswaehlen: "Choose file",
  tabelleAusDokument: "Create table from document",
  mitDokumentUnterhalten: "Chat with document",
  zusammenfassungWirdGeneriert: "Summary is being generated …",
  zusammenfassungFehlgeschlagen: "Summary failed.",

  // Feedback
  ladenFehlgeschlagen: "Documents could not be loaded",
  hochgeladenToast: "Uploaded",
  embeddingLaeuft: (datei: string) => `${datei} — embedding runs in the background`,
  uploadFehlgeschlagen: "Upload failed",
  wirklichLoeschen: (titel: string) => `Really delete “${titel}”?`,
  chunksUndVektoren: "Chunks and vectors go with it.",
  chunksUndVektorenKurz: "Chunks & vectors go with it.",
  dokumentGeloescht: "Document deleted",
  loeschenFehlgeschlagen: "Deletion failed",
  chatErstellungFehlgeschlagen: "Could not create chat",

  // ---- Detail (DocumentDetail.tsx) ----
  laden: "Loading …",
  verarbeitungFertig: "Processing finished",
  bilderAnzahl: (n: number) => (n === 1 ? "1 image" : `${n} images`),
  tabellenAnzahl: (n: number) => (n === 1 ? "1 table" : `${n} tables`),
  dokumentNichtGefunden: "Document not found",
  tabelleNichtErstellt: "Table could not be created",
  tabellenErstellt: (n: number) => `${n} table${n === 1 ? "" : "s"} created`,
  extraktionImHintergrund: "Extraction runs in the background.",
  tabellenNichtErstellt: "Tables could not be created",
  verarbeitungFehlgeschlagen: "Processing failed",
  docAiFehler:
    "doc-ai could not extract this document. Please upload it again or check the original.",

  aktionen: "Actions",
  anpassen: "Customise …",
  anpassenTitel: "Adjust columns & extraction yourself",
  vorschlagWirdVorbereitet: "Table suggestion is being prepared …",
  zusammenfassung: "Summary",
  wirdGeneriert: "being generated …",
  fehler: "Error",
  keine: "(none)",

  tabellenVorschlaege: "Table suggestions",
  tabellenVorschlag: "Table suggestion",
  alleErstellen: "Create all",
  wartenAufZusammenfassung: "The summary is still being generated – one moment please …",
  dokumentWirdVerarbeitet: "The document is still being processed …",
  keinVorschlagVerfuegbar: "No table suggestion available yet",
  weitereOhneSchema: (n: number) =>
    `more ${n === 1 ? "table" : "tables"} without a schema suggestion.`,
  schemaSelbstDefinieren: "Use “Customise …” to define a schema for them yourself.",

  erstellteTabellen: "Created tables",
  metadaten: "Metadata",
  status: "Status",
  bilder: "Images",
  tabellen: "Tables",
  hochgeladen: "Uploaded",
  hochgeladenVon: "Uploaded by",
  projekt: "Project",
  ansehen: "view",

  // Schema card
  tabelle: "Table",
  zeileIst: (einheit: string) => `Row = ${einheit}`,
  spaltenAnzahl: (n: number) => (n === 1 ? "1 column" : `${n} columns`),
  zeilenErwartet: (n: number) => `~${n} rows expected`,
  erstellen: "Create",
  tabelleSeite: (seite: number) => `Table p. ${seite}`,
  kiSchema: "AI schema",

  // Original view
  inhaltExtrahiert: "Content extracted & searchable in chat",
  inhaltExtrahiertHinweis:
    "The text of this document is vectorised in doc-ai and can be found via “Chat with document”. The uploaded original is shown below.",
  originalNichtGeladen: (fehler: string) => `The original could not be loaded: ${fehler}`,
  ladeOriginal: "Loading original …",
  inNeuemTab: "In a new tab",
  keineVorschau: "No inline preview for this format — download it to open.",

  // Processing skeleton
  docAiVerarbeitet: "doc-ai is processing (Mistral OCR + captioning) …",
  embeddingsWerdenBerechnet: "Embeddings are being computed …",
  wartetAufDocAi: "Waiting for doc-ai …",
  verarbeitetSeit: (dauer: string) => `processing for ${dauer} · typically 30–180s`,
};
